import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vSelect from 'vue-select';
import initialiseToasts from './toast-notifications';
import defineComponents from '@/components/define-components';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChalkboardTeacher, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

require( '@/styles/main.scss' );

// Register the two FontAwesome icons we need to use.
library.add( faChalkboardTeacher, faPhoneAlt );

// Define and install all components from the `@/components` dir.
// This isn't technically necessary but it saves us having to import
// our custom components each time we want to use them.
defineComponents( Vue );

// Initialise VueToasted for toast notifications
initialiseToasts( Vue );

// Add additional components
Vue.component( 'v-select', vSelect );
Vue.component( 'font-awesome-icon', FontAwesomeIcon );

Vue.config.productionTip = false;

new Vue( {
	router,
	store,
	render: h => h( App ),
} ).$mount( '#app' );
